<script setup lang="ts">
import { ClaimTypeName, getDisplayName, claimTypeByName } from '@/utils/config/constants/claims-types';

defineProps({
  name: {
    required: true,
    type: String as () => ClaimTypeName // cast it
  },
  emoji: {
    required: false,
    type: Boolean
  },
  textOnly: {
    required: false,
    type: Boolean
  },
});

type BadgesClaimType = {
  [name in ClaimTypeName]: {
    color: string;
    class: string;
  };
};

const badges: BadgesClaimType = {
  FLIGHT_DELAY: {
    color: "orange",
    class: 'bg-orange-50 text-orange-700 ring-orange-600/10',
  },
  FLIGHT_CANCELLATION: {
    color: "red",
    class: 'bg-red-50 text-red-700 ring-red-600/10',
  },
  PNR_SEGMENT_CANCELLATION: {
    color: "red",
    class: 'bg-red-50 text-red-700 ring-red-600/10',
  },
  DELAY_FROM_PNR_SCHEDULE: {
    color: "amber",
    class: 'bg-amber-50 text-amber-700 ring-amber-600/10',
  },
  MISSED_CONNECTION_DUE_TO_DELAY: {
    color: "indigo",
    class: 'bg-indigo-50 text-indigo-700 ring-indigo-600/10',
  },
  CONNECTION_DISRUPTION: {
    color: "indigo",
    class: 'bg-teal-50 text-teal-700 ring-teal-600/10',
  },
  OVERBOOKING: {
    color: "violet",
    class: 'bg-violet-50 text-violet-700 ring-violet-600/10',
  },
  WRONG_ARRIVAL_AIRPORT: {
    color: "teal",
    class: 'bg-teal-50 text-teal-700 ring-teal-600/10',
  },
  COVID_ORDINANCE_2020: {
    color: "blue",
    class: 'bg-blue-50 text-blue-700 ring-blue-600/10',
  },
}
</script>
<template>
  <span
    v-if="!textOnly"
    class="inline-flex items-center px-2.5 py-0.5 ring-1 ring-inset rounded-md text-xs font-medium capitalize"
    :class="badges[name].class"
  >
    {{ getDisplayName(name, { emoji }) }}
  </span>
  <span v-else class="py-0.5" :class="`text-gray-700`">
    {{ getDisplayName(name, { emoji }) }}
  </span>
</template>